import { enableProdMode, LOCALE_ID, provideAppInitializer, inject, ErrorHandler, importProvidersFrom, Injector, provideZoneChangeDetection } from '@angular/core';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule, MissingTranslationHandler } from '@ngx-translate/core';
import { ValidationService, FactorConfigurationService, AppBaseConfiguration, AppErrorHandler, VersionInterceptor, ErrorInterceptor, getDatepickerConfig, TelemetryInitializer, getDaterangepickerConfig, AppMissingTranslationHandler } from '@aston/foundation';
import { Store } from '@ngrx/store';
import { BsDatepickerConfig, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterOutlet } from '@angular/router';
import { USER_FILTERS_CONNECTOR } from '@aston/filters';

import { translateLoader, appConfigurationFactory } from './app/app.module';
import { environment } from './environments/environment';
import { currentTenantId } from './app/authentication-module/functions/utils.functions';
import { AppConfiguration } from './app/app.configuration';
import { FederationValidationService, FederationFactorConfigurationService } from './app/shared-module/services';
import { provideDebugBar } from './app/app.connectors';
import { AppRoutingModule } from './app/app-routing.module';
import { AuthenticationModule } from './app/authentication-module/authentication.module';
import { RootStoreModule } from './app/root-store';
import { AppComponent } from './app/app.component';

// check/store the tenant id before any redirection
console.log(`[init] app as T${currentTenantId()}`);

if (environment.production) {
	enableProdMode();
}

bootstrapApplication(AppComponent, {
	providers: [
		provideZoneChangeDetection(),importProvidersFrom(AppRoutingModule, AuthenticationModule, BrowserModule, TranslateModule.forRoot({
			missingTranslationHandler: {
				provide: MissingTranslationHandler,
				useClass: AppMissingTranslationHandler,
			},
			loader: {
				provide: TranslateLoader,
				useFactory: (translateLoader),
				deps: [HttpClient, AppConfiguration]
			}
		}), NgbTooltipModule, RootStoreModule, RouterOutlet),
		AppConfiguration,
		{
			provide: LOCALE_ID,
			useValue: 'fr-FR'
		},
		{
			provide: ValidationService,
			useClass: FederationValidationService,
		},
		{
			provide: FactorConfigurationService,
			useClass: FederationFactorConfigurationService,
		},
		{
			provide: AppBaseConfiguration,
			useExisting: AppConfiguration
		},
		provideAppInitializer(() => {
			const initializerFn = appConfigurationFactory(inject(Store));
			return initializerFn();
		}),
		{
			provide: USER_FILTERS_CONNECTOR,
			useFactory: () => undefined,
		},
		{
			provide: ErrorHandler,
			useClass: AppErrorHandler
		},
		{ provide: HTTP_INTERCEPTORS, useClass: VersionInterceptor, multi: true, deps: [Injector] },
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true, deps: [Injector] },
		{
			provide: BsDatepickerConfig,
			useFactory: getDatepickerConfig
		},
		{
			provide: TelemetryInitializer,
			useValue: null,
		},
		{
			provide: BsDaterangepickerConfig,
			useFactory: getDaterangepickerConfig
		},
		provideDebugBar(),
		provideHttpClient(withInterceptorsFromDi()),
		provideAnimations()
	]
})
	.catch(err => console.error(err));
